import { createRoute } from '@tanstack/react-router';

import { rootRoute } from '../../router/routes/rootRoute';

export const serviceSettingsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/service-settings',
});
